import React from "react";
import { IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import AppTable from "components/Shared/AppTable";

const VendorProfileDocumentList = ({
    documents,
    isBusy = false,
    totalDocuments,
    perPage,
    currentPage,
    handlePageChange,
    handlePerRowsChange,
}) => {
    const documentList = React.useMemo(() => documents || [], [documents]);

    const columns = React.useMemo(
        () => [
            {
                name: "Title",
                selector: (row) => row?.title,
                cell: (row) => (
                    <div title={row?.title} className="line-clamp-2">
                        {row?.title}
                    </div>
                ),
                minWidth: "150px",
            },
            {
                name: "Document Type",
                selector: (row) => row?.vendorDocumentType?.name,
                cell: (row) => <div>{row?.vendorDocumentType?.name || "N/A"}</div>,
                minWidth: "120px",
            },
            {
                name: "Attachments",
                cell: (row) =>
                    row?.attachments?.length > 0 ? (
                        <div className="flex gap-1">
                            {row.attachments.map((attachment) => (
                                <IconButton
                                    key={attachment?._id || attachment?.url}
                                    size="small"
                                    aria-label="View attachment"
                                    onClick={() => window.open(attachment?.url, "_blank")}
                                >
                                    <Visibility color="primary" />
                                </IconButton>
                            ))}
                        </div>
                    ) : (
                        <span>No attachments</span>
                    ),
                minWidth: "150px",
            },
        ],
        []
    );

    return (
        <AppTable
            columns={columns}
            data={documentList}
            paginationServer
            paginationPerPage={perPage}
            paginationDefaultPage={currentPage}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            progressPending={isBusy}
            paginationTotalRows={totalDocuments}
        />
    );
};

export default VendorProfileDocumentList;